import { FaEdit } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import AppState from '../../../../store/appstate';
import { getSocieties, getMyAccount } from '../../../../api/queries';
import ButtonPrimaryText from '../../../../components/buttonPrimaryText';
import Spacer from '../../../../components/spacer';
import WritersSongsTable from './WriterSongsTable';
import { hasAdminRights } from '../../../../auth/shared';

function WriterDetails(props) {
  const { t } = useTranslation('writers');
  const { row, setEditModal, highlightColour } = props;
  const { original } = row;

  let proName = null;

  const societies = getSocieties();
  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });
  const adminRights = hasAdminRights(myAccount?.data);
  if (societies.isSuccess && societies?.data && original.societycisaccode) {
    const pro = societies.data.societies.find((s) => s.cisaccode === original.societycisaccode);
    proName = pro?.name;
  }

  return (
    <tr>
      <td colSpan="5">
        <div className="rounded-lg bg-sentric-menu-gray lg:p-6 p-4 mb-2 mt-2 text-song-sub-color lg:w-screen-width-minus-gutter w-full">
          <div className="flex flex-wrap">
            <div className="w-full lg:w-1/2 flex items-center">
              <h2 className="font-bold text-sentric-table-text">
                {original?.firstname}
                {' '}
                {original?.middlename}
                {' '}
                {original?.lastname}
              </h2>
            </div>
            <div className="w-full lg:w-1/2 flex justify-end">
              <ButtonPrimaryText
                onClick={adminRights ? () => setEditModal(original.writercode) : undefined}
                disabled={!hasAdminRights}
              >
                <FaEdit className="mr-2 inline-block" />
                {t('writers:edit-writer')}
              </ButtonPrimaryText>
            </div>
          </div>
          <Spacer thin />
          <div className="flex flex-wrap">
            <div className="w-full lg:w-1/3">
              <p className="text-xs">
                <span className="uppercase font-semibold">
                  {t('writers:_membership')}
                  :
                </span>
                {' '}
                {proName}
              </p>
            </div>
            <div className="w-full lg:w-1/3">
              <p className="text-xs">
                <span className="uppercase font-semibold">
                  {t('writers:_publisher')}
                  :
                </span>
                {' '}
                {original.publishername}
              </p>
            </div>
            <div className="w-full lg:w-1/3">
              <p className="text-xs">
                <span className="uppercase font-semibold">CAE / IPI #:</span>
                {' '}
                {original.caeipinumber}
              </p>
            </div>

          </div>
          <Spacer thin />
          <WritersSongsTable
            highlightColour={highlightColour}
            writercode={original.writercode}
          />
        </div>

      </td>
    </tr>
  );
}

export default WriterDetails;
